import { render, staticRenderFns } from "./CompanyStakeReportLegacy.vue?vue&type=template&id=7745e872"
import script from "./CompanyStakeReportLegacy.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyStakeReportLegacy.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.1_webpack@5.74.0_esbuild@0.28.1___lodash@4.17.21_pret_109f61365412ffe5355524363be3c32c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports